// extracted by mini-css-extract-plugin
module.exports = {"switch":"toggleButton_switch__1cwBP","slider":"toggleButton_slider__2ybGb","round":"toggleButton_round__1QK3H","helpIcon":"toggleButton_helpIcon__3aMKp"};